import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from '@justgiving/react-tracking';
import { useTranslation } from 'react-i18next';
import config from '../../config';

import InviteMembersModal from '../InviteMembersModal';
import { IAppState } from '../../types/state.d';
import { getProductType, getShortName } from '../../selectors/apiSelectors';
import ProductName from '../../consts/productType';

type Props = MapStateToProps;
export const InviteMembers = ({ shortName, productType }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const shareUrl =
    productType === ProductName.InMemoryTeam
      ? `${config.baseFrpUri}/remember/${shortName}?invite=true`
      : `${config.basePageUri}${shortName}?invite=true`;

  return (
    <>
      <div className="jg-tc-button-container jg-tc-button-container__align-left jg-space-mvmd">
        <Button
          data-qa="invite-team-members"
          className="jg-btn"
          onClick={() => setIsModalOpen(true)}
          aria-haspopup="true"
          type="button"
          trackingData={{
            page_type: 'team page',
            action_name: 'click',
            subtype: 'button',
            event: 'click',
            event_value: 'invite members',
            page_section: 'admin > members',
          }}
        >
          {t('content.editmembers.button.invitemembers')}
        </Button>
      </div>
      <InviteMembersModal
        shareMessage={t('global.shareMessage')}
        shareHeader={t('global.shareHeader')}
        shareURL={shareUrl}
        onCloseModal={() => setIsModalOpen(false)}
        fbAppId={config.fbAppId}
        isModalOpen={isModalOpen}
      />
    </>
  );
};
type MapStateToProps = {
  shortName: string;
  productType: string;
};
const mapStateToProps = (state: IAppState) => ({
  shortName: getShortName(state),
  productType: getProductType(state) || '',
});
export default connect(mapStateToProps)(InviteMembers);
